import * as React from "react";

import { generateValidClassNameHandler } from "@/lib/utils";

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> { isMini?: boolean }

const Input = React.forwardRef<HTMLInputElement, InputProps>(
    ({
        className,
        type,
        ...props
    }, ref) => (
        <input
            ref={ref}
            type={type}
            className={generateValidClassNameHandler(
                `${props.isMini ? "md:min-w-[100px]" : "md:min-w-[250px]"} flex h-10 w-full rounded bg-gray-50 border border-gray-300 outline-none px-3 py-2 text-xs md:text-sm placeholder:text-gray-500 focus:outline-none focus:border-primary focus:border disabled:cursor-not-allowed disabled:opacity-50`,
                className,
            )}
            {...props}
        />
    ),
);
Input.displayName = "Input";

export { Input };
